import { createSelector } from '@ngrx/store';
import { docsFeature } from '../docs/docs.reducer';
import { docKey } from '../docs/docs.normalize';
import { selectActiveProjectId } from '../workspace/workspace.selectors';
import { ChatMessage } from './design.models';

const { selectEntities, selectKeyIndex, selectStatusByKey, selectErrorByKey } = docsFeature;

function dataFor(
  entities: ReturnType<typeof selectEntities>,
  keyIndex: Record<string, string>,
  pid: string | null,
  key: string
): any {
  if (!pid) return null;
  const id = keyIndex[docKey(pid, key)];
  return id ? entities.entities[id]?.data ?? null : null;
}

export const selectDesignChatMessages = createSelector(
  selectActiveProjectId,
  selectEntities,
  selectKeyIndex,
  (pid, e, k): ChatMessage[] => {
    const d = dataFor(e, k, pid, 'design.chat');
    return Array.isArray(d?.messages) ? (d.messages as ChatMessage[]) : [];
  }
);

export const selectDesignLoading = createSelector(selectActiveProjectId, selectStatusByKey, (pid, s) =>
  pid ? s[docKey(pid, 'design.chat')] === 'loading' : false
);

export const selectDesignError = createSelector(selectActiveProjectId, selectErrorByKey, (pid, e) =>
  pid ? e[docKey(pid, 'design.chat')] ?? null : null
);
